@if (isOpen()) {
  <div class="nav-menu-panel" role="dialog" aria-modal="true" aria-label="ナビゲーションメニュー">
    <ul class="nav-menu-list" role="list">
      @for (item of items(); track item.action) {
        <li class="nav-menu-item" role="listitem">
          <button class="nav-menu-item-btn" type="button" (click)="onItemClick(item.action)">
            <div class="nav-menu-item-label">
              <span class="nav-menu-item-icon-wrap" aria-hidden="true">
                <img class="nav-menu-item-svg-icon" [src]="item.iconSrc" alt="" />
              </span>
              <span class="nav-menu-item-text">{{ item.label }}</span>
            </div>
          </button>
        </li>
      }
    </ul>
  </div>
}
